var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CHeader',{attrs:{"val":_vm.val},on:{"childEvent":_vm.getShow}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('CMenu'),_vm._v(" "),_c('div',{staticClass:"rightContent"},[_c('router-view',{on:{"childEvent":_vm.getShow}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d793bac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/console.vue
// module id = null
// module chunks = 